module.exports = __webpack_public_path__ + "static/img/preview.94fb8bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/ninjatown-banner-campaign/preview.png
// module id = 103
// module chunks = 2